var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "arrival-wrap",
      on: {
        click: function ($event) {
          return _vm.$emit("closed")
        },
      },
    },
    [
      _c("transition", { attrs: { name: "gift" } }, [
        _vm.isShowContent
          ? _c("div", { staticClass: "content" }, [
              _c("div", { staticClass: "txt" }, [
                _vm._v(_vm._s(_vm.$t("txt_congrats"))),
              ]),
              _c("div", { staticClass: "gifts", class: _vm.options.type }),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }